module.exports = __webpack_public_path__ + "img/蒙版组 10@2x (1).7d747c07.webp";